<template>
  <v-card style="border-bottom: 2px solid #999;">
    <v-card-title class="subtitle-1"> Add UAT Test Setup </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-text-field
          v-model="testSetupRecord.setupIdentifier"
          :rules="identifierRules"
          label="Identifier *"
        ></v-text-field>

        <v-textarea v-model="testSetupRecord.setup" :rules="setupRules" label="Setup *"></v-textarea>

        <v-card-actions>
          <v-btn @click="cancel" outlined>Cancel</v-btn>
          <v-btn color="primary" :disabled="!valid" @click="save">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "individualTestSetupForm",
  components: {},
  computed: {},
  data() {
    return {
      identifierRules: [identifier => !!identifier || "Identifier is required"],
      setupRules: [setup => !!setup || "Setup is required"],
      testSetupRecord: {
        isNew: true,
        setup: "",
        setupA: null,
        setupIdentifier: "",
      },
      valid: true,
    };
  },
  methods: {
    cancel() {
      this.$emit("testSetupCancel");
      this.resetForm();
    },
    resetForm() {
      this.testSetupRecord = {
        isNew: true,
        setup: "",
        setupA: null,
        setupIdentifier: "",
      };
    },
    save() {
      this.$emit("testSetupSubmission", this.testSetupRecord);
      this.resetForm();
    },
  },
};
</script>
